module.exports = __webpack_public_path__ + "img/icon_map_gzljx.c9251714.png";